"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AdvancedFeatures = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AdvancedFeatures_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0c.27 0 .518.153.639.395l1.322 2.644 2.644 1.322a.714.714 0 0 1 0 1.278L12.961 6.96l-1.322 2.644a.714.714 0 0 1-1.278 0L9.04 6.961 6.395 5.639a.714.714 0 0 1 0-1.278L9.039 3.04 10.361.395A.714.714 0 0 1 11 0ZM3.5 8a.7.7 0 0 1 .626.387l.83 1.658 1.657.829a.7.7 0 0 1 0 1.252l-1.658.83-.829 1.657a.7.7 0 0 1-1.252 0l-.83-1.658-1.657-.829a.7.7 0 0 1 0-1.252l1.658-.83.829-1.657A.7.7 0 0 1 3.5 8ZM14.245 11.46a.833.833 0 0 0-1.49 0l-.432.863-.862.432a.833.833 0 0 0 0 1.49l.862.432.432.862a.833.833 0 0 0 1.49 0l.432-.862.862-.432a.834.834 0 0 0 0-1.49l-.862-.432-.432-.862Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AdvancedFeatures_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AdvancedFeatures;
exports["default"] = _default;